import React, { useEffect, useState } from 'react';
import { useNavigate } from '../nav';
import { AVAILABLE_BALANCE, ACCOUNT_NAME, VE_BANK_ASSETS } from '../lib/brand';
import { BottomNav } from '../components/BottomNav';
import { CustomIcon } from '../components/CustomIcons';
import { VeeMascot } from '../components/VeeMascot';
const actions = [{
  label: 'Send',
  icon: VE_BANK_ASSETS.actionSend,
  path: '/transfer',
  aria: 'Send money'
}, {
  label: 'Airtime',
  icon: VE_BANK_ASSETS.actionAirtime,
  path: '/bill?service=Airtime',
  aria: 'Buy airtime'
}, {
  label: 'Bills',
  icon: VE_BANK_ASSETS.actionBills,
  path: '/bills',
  aria: 'Pay bills'
}, {
  label: 'Card',
  icon: VE_BANK_ASSETS.actionCards,
  path: '/account',
  aria: 'Manage cards'
}];
const defaultFavourites = ['Send', 'Airtime', 'Bills'];
export function Home() {
  const navigate = useNavigate();
  const [mode, setMode] = useState<'voice' | 'text'>('voice');
  const [favourites, setFavourites] = useState<string[]>(() => {
    try {
      return JSON.parse(window.localStorage.getItem('ve-favourites') || 'null') || defaultFavourites;
    } catch {
      return defaultFavourites;
    }
  });
  const [notice, setNotice] = useState('');
  useEffect(() => {
    window.localStorage.setItem('ve-favourites', JSON.stringify(favourites));
  }, [favourites]);
  const flash = (message: string) => {
    setNotice(message);
    window.setTimeout(() => setNotice(''), 1800);
  };
  return <main className="flex h-full max-h-full w-full flex-col overflow-hidden bg-brand-cloud" data-id="element-485" data-mp="2hxx974512qxs">
      <div className="phone-scroll flex min-h-0 flex-1 flex-col overflow-y-auto" data-id="element-486" data-mp="2hzqfujfn5b5s">
      {/* Account surface — balance and cash flow, sized to support the assistant rather than compete with it. */}
      <section className="relative shrink-0 overflow-hidden bg-[#061827] px-5 pb-14 pt-12 text-white" data-id="element-487" data-mp="285riryufchkp">
        <div aria-hidden="true" className="absolute -right-14 top-6 h-44 w-44 rounded-full bg-brand-purple/45 blur-3xl" data-id="element-488" data-mp="1z7fwua4i67yl" />
        <header className="relative flex items-center justify-between" data-id="element-489" data-mp="1u7t8b4j855ah">
          <div className="flex items-center gap-2" data-id="element-490" data-mp="1uap7ew6t600i">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-white" data-id="element-491" data-mp="1kjxo90ntkt6w">
              <img src={VE_BANK_ASSETS.appIcon} alt="" className="h-6 w-6 object-contain" data-id="element-492" data-mp="1ondhdn0okbeu" />
            </span>
            <span className="text-sm font-extrabold" data-id="element-493" data-mp="1anulptp22sjf">Good afternoon, Chidi</span>
          </div>
          <button onClick={() => navigate('/profile')} aria-label="Open profile" className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/10" data-id="element-494" data-mp="1fmfcl2if3zv7">
            <CustomIcon name="profile" size={18} data-id="element-495" data-mp="28a1qp4p9umwb" />
          </button>
        </header>

        <button onClick={() => navigate('/account')} className="relative mt-6 w-full text-left" data-id="element-496" data-mp="1tlf2edho2ksy">
          <div className="flex items-end justify-between" data-id="element-497" data-mp="1yki7tz1k6t1g">
            <div data-id="element-498" data-mp="1yixci77f762j">
              <p className="text-[11px] font-bold uppercase tracking-[.15em] text-blue-200" data-id="element-499" data-mp="1yif8upifhpkl">{ACCOUNT_NAME}</p>
              <h1 className="mt-2 text-[34px] font-extrabold tracking-[-.06em] tabular-nums" data-id="element-500" data-mp="2m89k52n3n62q">{AVAILABLE_BALANCE}</h1>
              <p className="mt-1 text-xs text-slate-300" data-id="element-501" data-mp="flkbhefstvbl">Available to use</p>
            </div>
            <span className="rounded-full bg-white/10 px-3 py-1.5 text-[10px] font-extrabold text-blue-100" data-id="element-502" data-mp="amqv9e94nq7q">VERIFIED</span>
          </div>
          <div className="mt-5 flex h-10 items-end gap-1.5 border-t border-white/10 pt-3" data-id="element-503" data-mp="od2qvn4x873m">
            {[28, 42, 24, 54, 32, 67, 38, 76, 49, 89, 54, 72].map((height, index) => <span key={index} className="data-shift w-full rounded-t-sm bg-[linear-gradient(180deg,#0EA5FF,#6747E8)] opacity-80" style={{
              height: `${height}%`,
              animationDelay: `${index * 80}ms`
            }} data-id="element-504" data-mp="3sru5fddyasf0" data-mpi={index} />)}
          </div>
          <div className="mt-2 flex justify-between text-[10px] font-bold text-slate-400" data-id="element-505" data-mp="5ofpbelydzus">
            <span data-id="element-506" data-mp="nrwqoi2tayg">Cash flow · 7 days</span>
            <span data-id="element-507" data-mp="qw763m4x2xk">+₦18,420 in</span>
          </div>
        </button>
      </section>

      <section className="relative -mt-10 shrink-0 space-y-5 px-5 pb-5" data-id="element-508" data-mp="1h0yn6qqkvwzv">
        {/* Signature surface: the assistant leads the screen. */}
        <section className="relative overflow-hidden rounded-[30px] bg-[linear-gradient(135deg,#10294a,#246BFE_56%,#6747E8)] p-6 text-white shadow-float" data-id="element-509" data-mp="27eeq0aobh1hx">
          <div aria-hidden="true" className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-brand-electric/30 blur-2xl" data-id="element-510" data-mp="2cd81jxk1mifg" />
          <div className="relative flex items-center justify-between" data-id="element-511" data-mp="2mb5s4rpdkrb8">
            <div className="flex items-center gap-3" data-id="element-512" data-mp="2m92rldqljfs9">
              <VeeMascot size={44} state={mode === 'voice' ? 'listening' : 'speaking'} decorative data-id="element-513" data-mp="2qdivxakkaf5d" />
              <p className="flex items-center gap-2 text-base font-extrabold" data-id="element-514" data-mp="2vb29e89fqnw9">
                Ask Vee
                <span aria-hidden="true" className="vee-status h-1.5 w-1.5 rounded-full bg-brand-electric" data-id="element-515" data-mp="303lm730atf00" />
              </p>
            </div>
            <div className="flex shrink-0 rounded-xl bg-black/20 p-1" role="tablist" aria-label="Vee input mode" data-id="element-516" data-mp="353q32u54cbqr">
              <button role="tab" aria-selected={mode === 'voice'} onClick={() => setMode('voice')} className={`rounded-lg px-2.5 py-1 text-[10px] font-extrabold ${mode === 'voice' ? 'bg-white text-brand-navy' : 'text-blue-100'}`} data-id="element-517" data-mp="3e2bkun2rnmqh">VOICE</button>
              <button role="tab" aria-selected={mode === 'text'} onClick={() => setMode('text')} className={`rounded-lg px-2.5 py-1 text-[10px] font-extrabold ${mode === 'text' ? 'bg-white text-brand-navy' : 'text-blue-100'}`} data-id="element-518" data-mp="ycbnvwrsri0j">TEXT</button>
            </div>
          </div>

          <button onClick={() => navigate(`/chat?mode=${mode}`)} className="relative mt-5 flex min-h-[56px] w-full items-center justify-between rounded-2xl bg-white/12 px-5 text-left text-sm font-bold backdrop-blur" data-id="element-519" data-mp="1m3h4ie5kaebw">
            <span className="flex items-center gap-3" data-id="element-520" data-mp="1cc4cnmjrjo5v">
              {mode === 'voice' && <span aria-hidden="true" className="flex items-end gap-0.5" data-id="element-521" data-mp="17euqcfro7sm9">
                  {[9, 15, 7, 13].map((height, index) => <span key={index} className="data-shift w-0.5 rounded-full bg-brand-electric" style={{
                  height,
                  animationDelay: `${index * 110}ms`
                }} data-id="element-522" data-mp="24urtuqvn2j1o" data-mpi={index} />)}
                </span>}
              {mode === 'voice' ? 'Tap to speak to Vee' : 'Ask Vee to prepare something'}
            </span>
            <span aria-hidden="true" className="text-brand-electric" data-id="element-523" data-mp="28mge0pcq1u1">↗</span>
          </button>
        </section>

        {/* Vee's proactive insight, delivered before any setup request. */}
        <section className="rounded-[25px] bg-white p-5 shadow-soft" data-id="element-524" data-mp="3phrlhy6pu253">
          <div className="flex items-start gap-3" data-id="element-525" data-mp="3al1u5673x234">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-brand-cobalt" data-id="element-526" data-mp="3flg5ax408s5d">
              <CustomIcon name="spark" size={18} data-id="element-527" data-mp="31moq17dep0fn" />
            </span>
            <div data-id="element-528" data-mp="36kzzvi3pbaxv">
              <p className="text-sm font-extrabold text-brand-navy" data-id="element-529" data-mp="36ki0wdpnmim9">Vee noticed</p>
              <p className="mt-1 text-xs leading-relaxed text-brand-slate" data-id="element-530" data-mp="zutldbpkhw6x">You have ₦160,000 left in today’s transfer limit. Your electricity payment is due in 4 days.</p>
              <button onClick={() => navigate('/chat')} className="mt-3 min-h-[44px] text-[11px] font-extrabold text-brand-cobalt" data-id="element-531" data-mp="14rkaeojco24h">Ask Vee about this</button>
            </div>
          </div>
        </section>

        <section data-id="element-532" data-mp="19wnrbysoolpc">
          <div className="mb-3 flex items-center justify-between" data-id="element-533" data-mp="1npn80447clyh">
            <h2 className="text-sm font-extrabold text-brand-navy" data-id="element-534" data-mp="1nrzxr3g7c0m3">Manual actions</h2>
            <button onClick={() => navigate('/account')} className="min-h-[44px] text-[11px] font-extrabold text-brand-cobalt" data-id="element-535" data-mp="1ixlw4jay4x8z">Manage account</button>
          </div>
          <div className="grid grid-cols-4 gap-2" data-id="element-536" data-mp="1sprnbqtdjan4">
            {actions.map(action => <div key={action.label} className="relative" data-id="element-537" data-mp="26p9fmg5vp618">
                <button onClick={() => navigate(action.path)} aria-label={action.aria} className="group flex min-h-[60px] w-full flex-col items-center justify-center gap-1.5 rounded-[16px] bg-white py-2 text-brand-navy shadow-soft transition-all duration-150 hover:-translate-y-[1px] hover:scale-[1.01] hover:bg-slate-50 focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-4 focus-visible:outline-brand-cobalt active:scale-[1.01] active:bg-slate-50 motion-reduce:transition-none motion-reduce:hover:translate-y-0 motion-reduce:hover:scale-100 motion-reduce:active:scale-100" data-id="element-538" data-mp="26mez2zpzk5d3">
                  <img src={action.icon} alt="" className="h-[24px] w-[24px] sm:h-[28px] sm:w-[28px]" data-id="element-539" data-mp="1akyi0gttbtgq" />
                  <span className="text-[9px] font-extrabold" data-id="element-540" data-mp="dx1x4zrcebzp">{action.label}</span>
                </button>
                <button onClick={() => editFavourite(action.label)} aria-label={`${favourites.includes(action.label) ? 'Remove' : 'Add'} ${action.label} favourite`} className={`absolute right-1.5 top-1.5 flex h-5 w-5 items-center justify-center rounded-full text-[10px] leading-none transition-colors ${favourites.includes(action.label) ? 'bg-brand-cobalt text-white' : 'bg-slate-100 text-brand-slate hover:bg-slate-200'}`} data-id="element-541" data-mp="iwei1eynl8zn">
                  {favourites.includes(action.label) ? '–' : '+'}
                </button>
              </div>)}
          </div>
        </section>

        {notice && <p role="status" className="rounded-xl bg-blue-50 px-3 py-2 text-center text-[10px] font-extrabold text-brand-cobalt" data-id="element-542" data-mp="23n7n59oztlzg">{notice}</p>}
      </section>
      </div>

      <BottomNav data-id="element-543" data-mp="1unb5hs10tndw" />
    </main>;
}